import styled from 'styled-components';

const MetaList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export { MetaList };
